import { lazily } from 'react-lazily'
/**
 * Layouts
 */
import { SingleAction } from 'layout'
import Guard from 'guards/Guard'
import {
  ViewBalanceByDNIReport,
  TransfersReport,
  ViewLiquidationReport,
  ViewAvailableASLByDNIReport,
  StudentsReport,
  ReportByDni,
  ViewASLOverviewReport,
  ViewAStatementByDNIReport,
} from 'pages/reports'

const { RoleReportes, ReportesButtonMenuLinks } = lazily(() =>
  import('pages/home')
)

//const { ReportByDNI } = lazily(() => import('pages/reports/ReportByDni'))
/**
 * Layouts
 */
const LAYOUTS = {
  singleAction: SingleAction,
}

const basePath = '/dashboard/reportes'

const reportesRoutes = [
  {
    name: 'role-reportes-home',
    path: basePath,
    element: RoleReportes,
    guard: Guard,
    guardProps: { allowedRoles: ['Reportes'] },
    homeForRole: ['Reportes'],
    suspenseFallback: null,
    childs: [
      {
        element: ReportesButtonMenuLinks,
        name: 'reportes-menu-buttons',
        path: 'disponibles',
        index: true,
      },
      {
        element: ViewASLOverviewReport,
        name: 'ASL-general-report',
        path: 'ASL-general',
        layout: LAYOUTS.singleAction,
        layoutProps: {
          title: 'Resumen de ASL general',
          parentRouteName: 'reportes-menu-buttons',
        },
      },
      {
        element: ViewBalanceByDNIReport,
        name: 'ASL-report-by-DNI',
        path: 'ASL-por-dni',
        layout: LAYOUTS.singleAction,
        layoutProps: {
          title: 'Resumen de ASL por DNI',
          parentRouteName: 'reportes-menu-buttons',
        },
      },
      {
        element: ReportByDni,
        name: 'ASL-transfers-by-DNI',
        path: 'ASL-transferencia-por-dni',
        layout: LAYOUTS.singleAction,
        layoutProps: {
          title: 'Transferencias de ASL por DNI',
          parentRouteName: 'reportes-menu-buttons',
        },
        elementProps: { title: 'DNI' },
      },
      {
        element: TransfersReport,
        name: 'ASL-transfers-by-DNI-report',
        path: 'ASL-transferencia-por-dni/:dni',
        layout: LAYOUTS.singleAction,
        layoutProps: {
          title: 'Transferencias de ASL por DNI',
        },
      },
      {
        element: TransfersReport,
        name: 'ASL-transfers-by-date',
        path: 'ASL-transferencia-por-fecha',
        layout: LAYOUTS.singleAction,
        layoutProps: {
          title: 'Transferencias de ASL por Fecha',
          parentRouteName: 'reportes-menu-buttons',
        },
      },
      {
        element: ReportByDni,
        name: 'ASL-paid-by-DNI',
        path: 'liquidaciones-ASL-por-dni',
        layout: LAYOUTS.singleAction,
        layoutProps: {
          title: 'Liquidaciones de ASL por DNI',
          parentRouteName: 'reportes-menu-buttons',
        },
        elementProps: { title: 'DNI' },
      },
      {
        element: ViewLiquidationReport,
        layout: LAYOUTS.singleAction,
        name: 'ASL-paid-by-DNI-list',
        layoutProps: {
          title: 'Liquidaciones de ASL por DNI',
          parentRouteName: 'ASL-paid-by-DNI',
        },
        path: 'liquidaciones-ASL-por-dni/:dni',
      },
      {
        element: ViewLiquidationReport,
        layout: LAYOUTS.singleAction,
        name: 'ASL-paid-by-date',
        path: 'liquidacion-de-ASL-por-fecha',
        layoutProps: {
          title: 'Liquidaciones de ASL por fecha',
          parentRouteName: 'reportes-menu-buttons',
        },
      },
      {
        element: ReportByDni,
        name: 'ASL-balance-by-DNI',
        path: 'saldo-ASL-por-dni',
        layout: LAYOUTS.singleAction,
        layoutProps: {
          title: 'Saldo de ASL por DNI',
          parentRouteName: 'reportes-menu-buttons',
        },
        elementProps: { title: 'DNI' },
      },
      {
        element: ViewAvailableASLByDNIReport,
        name: 'ASL-balance-by-DNI-report',
        path: 'saldo-ASL-por-dni/:dni',
        layout: LAYOUTS.singleAction,
        layoutProps: {
          title: 'Saldo de ASL por DNI',
          parentRouteName: 'ASL-balance-by-DNI',
        },
      },
      {
        element: StudentsReport,
        name: 'students-report',
        path: 'alumnos',
        layout: LAYOUTS.singleAction,
        layoutProps: {
          title: 'Alumnos',
          parentRouteName: 'reportes-menu-buttons',
        },
      },
      {
        element: ReportByDni,
        name: 'ASL-statement-by-DNI',
        path: 'estado-de-cuenta-de-ASL-por-dni',
        layout: LAYOUTS.singleAction,
        layoutProps: {
          title: 'Estado de cuenta de ASL por DNI',
          parentRouteName: 'reportes-menu-buttons',
        },
        elementProps: { title: 'DNI' },
      },
      {
        element: ViewAStatementByDNIReport,
        name: 'ASL-statement-by-DNI-report',
        path: 'estado-de-cuenta-de-ASL-por-dni/:dni',
        layout: LAYOUTS.singleAction,
        layoutProps: {
          title: 'Estado de cuenta de ASL por DNI',
          parentRouteName: 'ASL-statement-by-DNI',
        },
      },
    ],
  },
]

export default reportesRoutes
